import { QueryClientProvider } from '@tanstack/react-query';
import { createBrowserHistory, RouterProvider } from '@tanstack/react-router';
import { useEffect, useMemo, useRef } from 'react';
import { PreferencesProvider } from './preferences.tsx';
import { queryClient } from './query-client.ts';
import { createAppRouter } from './router.tsx';
import { useSession } from './use-session.ts';

const history = createBrowserHistory();

export function App() {
  const session = useSession();

  const principalRef = useRef<string | null>(null);
  useEffect(() => {
    const principal = session.status === 'signed-in' ? session.session.user.id : null;
    if (principalRef.current !== null && principalRef.current !== principal) {
      queryClient.clear();
    }
    principalRef.current = principal;
  }, [session]);

  const router = useMemo(() => createAppRouter({ auth: session, history }), [session]);

  if (session.status === 'loading') {
    return (
      <main className="flex min-h-dvh items-center justify-center">
        <p role="status" aria-live="polite">
          Loading…
        </p>
      </main>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <PreferencesProvider>
        <RouterProvider router={router} />
      </PreferencesProvider>
    </QueryClientProvider>
  );
}
